import extendBaseIcon from '../extendBaseIcon';
/* eslint-disable import/no-unresolved */
// ?react on svg path is required for svgr plugin used to import svgs as react components, so disable no-unresolved
import ImproveIconSvg from '../svg/icon_functional_improve.svg?react';

const ImproveIcon = extendBaseIcon(ImproveIconSvg);
export default ImproveIcon;
